import { useToggle } from '@vueuse/core'
import { onMounted } from 'vue'
import { getParentEl, getChildEl } from '@el-plus/utils'
import { ref, computed, useTemplateRef, type SetupContext } from 'vue'
import type { titleEmits } from './title'
export const useTitle = (emit: SetupContext<typeof titleEmits>['emit']) => {
  const [value, toggle] = useToggle(true)
  const expanded = value
  const contentRef = useTemplateRef<HTMLElement>('contentRef')
  onMounted(() => {
    contentRef.value!.addEventListener('transitionend', (e) => {
      if (e.propertyName === 'max-height') {
        if (!expanded.value) {
          // 收起动画结束后隐藏
          contentRef.value!.style.display = 'none'
        } else {
          contentRef.value?.style.removeProperty('max-height')
        }
      }
    })
  })

  const toggleState = (e: MouseEvent) => {
    let contentHeight = getContentHeight(e.target as HTMLElement) + 'px'
    if (expanded.value) {
      contentRef.value!.style.maxHeight = contentHeight
    } else {
      contentRef.value?.style.removeProperty('display')
      contentHeight = getContentHeight(e.target as HTMLElement) + 'px'
    }
    requestAnimationFrame(() => {
      contentRef.value!.style.maxHeight = expanded.value ? '0' : contentHeight
      toggle()
      emit('toggle', expanded.value)
    })
  }
  // 获取高度
  const getContentHeight = (target: HTMLElement) => {
    const parentEl = getParentEl(target, 'ep-title')!
    const contentEl = getChildEl(parentEl, 'ep-title__content')
    return contentEl?.scrollHeight || 0
  }
  return {
    expanded,
    toggleState,
  }
}
